import { IGroupConfigurationData } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";

export class ClearEffectiveDateTransformer extends BaseJsonTransformer {
    async transformGroupConfiguration(json: IGroupConfigurationData): Promise<void> {
        json.effectiveDate = null;
    }
}